export const routerManualBook = [
  {
    path: 'manual-book/:slug',
    meta: { title: 'Manual Book' },
    component: () => import('@/views/manual-book/index.vue'),
  },
]
